import App from "@/views/App.vue";

export default [
  {
    path: "/meu-perfil",
    name: "profile",
    component: App,
    redirect: { name: "profileHome" },
    children: [
      {
        path: "",
        name: "profileHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewProfile.vue"),
        meta: {
          displayName: "displayName.myProfile",
          requiresAuth: true,
        },
      },
      {
        path: "/perfil/:id",
        name: "profileCLevel",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewProfileCLevel.vue"
          ),
        meta: {
          displayName: "displayName.profileClevel",
          requiresAuth: true,
        },
      },
      {
        path: "/perfil-marketing/:id",
        name: "profileMarketing",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewProfileMarketing.vue"
          ),
        meta: {
          displayName: "displayName.profileMarketing",
          requiresAuth: true,
        },
      },
      {
        path: "/meu-perfil/editar-informacoes",
        name: "profileEditInfo",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditProfile.vue"),
        meta: {
          displayName: "displayName.editProfile",
          requiresAuth: true,
        },
      },
      {
        path: "/meu-perfil/novo-card/:id",
        name: "profileNewCard",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewCard.vue"),
        meta: {
          displayName: "displayName.newCard",
          requiresAuth: true,
        },
      },
      {
        path: "/meu-perfil/editar-card/:id/",
        name: "profileEditCard",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditCard.vue"),
        meta: {
          displayName: "displayName.newCard",
          requiresAuth: true,
        },
      },
      {
        path: "/novo-meu-perfil",
        name: "newProfileHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewProfile.vue"),
        meta: {
          displayName: "displayName.myProfile",
          requiresAuth: true,
        },
      },
      {
        path: "/passo-perfil/:redirect_to?/:redirect_params?/:redirect_params_last?",
        name: "profileStep",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/StepProfile.vue"),
        meta: {
          displayName: "displayName.myProfile",
          requiresAuth: true,
        },
      },
      // {
      //   path: "/minhas-comunidades",
      //   name: "profileCommunities",
      //   component: () =>
      //     import(/* webpackChunkName: "about" */ "../views/Community.vue"),
      //   meta: {
      //     displayName: "Minhas comunidades - Exclusive Lounge",
      //     requiresAuth: true,
      //   },
      // },
      {
        path: "/formulario-case",
        name: "profileCase",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/SubmitCase.vue"),
        meta: {
          displayName: "Formulário case - Exclusive Lounge",
          requiresAuth: true,
        },
      },
    ],
  },
];
